{
  "acciones": {
    "guardar": "Save",
    "cancelar": "Cancel",
    "buscar": "Search",
    "volver": "Back",
    "confirmar": "Confirm",
    "reintentar": "Retry",
    "salir": "Sign out",
    "activar": "Activate",
    "desactivar": "Deactivate",
    "agregar": "Add",
    "siguiente": "Next",
    "imprimir": "Print",
    "quitar": "Remove",
    "corregir": "Correct"
  },
  "estados": {
    "cargando": "Loading…",
    "vacio": "Nothing to show yet",
    "error": "The operation could not be completed"
  },
  "tema": {
    "titulo": "Theme",
    "claro": "Light",
    "oscuro": "Dark",
    "sistema": "System"
  },
  "idioma": {
    "titulo": "Language"
  },
  "salud": {
    "titulo": "System status",
    "operativo": "Operational",
    "degradado": "Degraded",
    "caido": "Down",
    "version": "Version",
    "entorno": "Environment",
    "tiempoActivo": "Uptime",
    "segundos": "{{cantidad}} s",
    "sinConexion": "The server status could not be retrieved",
    "estado": "Status"
  },
  "navegacion": {
    "titulo": "Sections",
    "contenido": "Content",
    "inicio": "Home",
    "sucursales": "Branches",
    "auditoria": "Audit trail",
    "empresaActiva": "Active company",
    "estructura": "Warehouses and registers",
    "gente": "People and roles",
    "configuracion": "Settings",
    "catalogo": "Items",
    "precios": "Prices",
    "existencias": "Stock",
    "caja": "Register",
    "mostrador": "Counter",
    "mayorista": "Wholesale",
    "proveedores": "Suppliers",
    "compras": "Purchases",
    "clientes": "Customers",
    "cuentas": "Accounts receivable",
    "pagos": "Supplier payments",
    "devoluciones": "Returns",
    "contabilidad": "Chart of accounts",
    "asientos": "Journal",
    "libros": "Books",
    "libroDeIva": "VAT Book",
    "ejercicios": "Fiscal years",
    "importacion": "Import",
    "bancos": "Banking",
    "comisiones": "Commissions",
    "produccion": "Assembly",
    "grupos": {
      "vender": "Sell",
      "stock": "Stock",
      "comprar": "Buy",
      "plata": "Money",
      "contabilidad": "Accounting",
      "configurar": "Settings",
      "administrar": "Administration"
    },
    "irA": "Go to…",
    "irAAyuda": "Type the name of a screen",
    "irASinNada": "No screen by that name.",
    "tiposDeComprobante": "Voucher types",
    "conversiones": "Invoice deliveries",
    "rubros": "Categories",
    "recalculo": "Recalculate prices",
    "numeradores": "Numbering series",
    "plegar": "Collapse the menu",
    "desplegar": "Expand the menu",
    "campos": "Custom fields",
    "plataforma": "Platform"
  },
  "acceso": {
    "subtitulo": "Sign in to your account",
    "subtituloSegundoFactor": "Second step",
    "correo": "Email",
    "contrasena": "Password",
    "codigo": "Code",
    "ayudaCodigo": "From your authenticator app, or a recovery code",
    "entrar": "Sign in",
    "confirmar": "Confirm",
    "titulo": "Sign in",
    "presentacion": "Commercial management for shops that sell every day."
  },
  "empresa": {
    "elegir": "Choose a company",
    "sinEmpresas": "You have no company yet",
    "ayudaSinEmpresas": "Once you register your business, it will show up here.",
    "administrarPlataforma": "Manage the platform",
    "suspendida": "Suspended by the platform"
  },
  "inicio": {
    "descripcion": "How the day is going.",
    "tuAcceso": "Your access",
    "persona": "Person",
    "permisos": "Permissions"
  },
  "sucursales": {
    "titulo": "Branches",
    "descripcion": "Your stores and warehouses.",
    "nueva": "New branch",
    "ayudaNueva": "The code cannot repeat within the company.",
    "codigo": "Code",
    "nombre": "Name",
    "ciudad": "City",
    "estado": "Status",
    "acciones": "Actions",
    "activa": "Active",
    "inactiva": "Inactive",
    "ayudaCodigo": "Short and easy to say out loud",
    "vacio": "No branches yet."
  },
  "modulos": {
    "organizacion": "Organization",
    "accesos": "Access",
    "auditoria": "Audit trail",
    "existencias": "Inventory",
    "caja": "Cash",
    "impuestos": "Taxes",
    "comisiones": "Commissions",
    "cuentas-corrientes": "Accounts",
    "comprobantes": "Documents",
    "produccion": "Manufacturing"
  },
  "opciones": {
    "FIFO": "FIFO",
    "PROMEDIO_PONDERADO": "Weighted average",
    "MITAD_AFUERA": "Commercial",
    "MITAD_PAR": "Banker",
    "AL_EMITIR": "On issue",
    "AL_COBRAR": "On payment",
    "MANUAL": "Manual",
    "MAS_ANTIGUO_PRIMERO": "Oldest first",
    "A_CUENTA": "On account",
    "EMISION": "From issue",
    "ENTREGA": "From delivery",
    "es-AR": "Spanish",
    "en": "English",
    "pt-BR": "Portuguese"
  },
  "estructura": {
    "titulo": "Warehouses and registers",
    "descripcion": "Everything that hangs off a branch.",
    "depositos": "Warehouses",
    "ayudaDepositos": "Where the stock is kept.",
    "cajas": "Registers",
    "ayudaCajas": "Where payments are taken.",
    "puntosDeVenta": "Points of sale",
    "ayudaPuntosDeVenta": "Legal document numbering runs per point of sale, not per branch.",
    "nuevoDeposito": "New warehouse",
    "nuevaCaja": "New register",
    "nuevoPuntoDeVenta": "New point of sale",
    "sinDepositos": "No warehouses yet.",
    "sinCajas": "No registers yet.",
    "sinPuntosDeVenta": "No points of sale yet.",
    "sucursal": "Branch",
    "elegirSucursal": "Choose a branch",
    "codigo": "Code",
    "nombre": "Name",
    "numero": "Number",
    "modo": "Issuing",
    "predeterminado": "Default",
    "si": "Yes",
    "ayudaNumero": "The one assigned by the tax authority",
    "modos": {
      "interno": "Internal",
      "manual": "Manual",
      "electronico": "Electronic",
      "controlador_fiscal": "Fiscal printer"
    },
    "corregir": "Correct",
    "enUso": "In use"
  },
  "gente": {
    "titulo": "People and roles",
    "descripcion": "Who is part of the business and what they can do.",
    "equipo": "Team",
    "roles": "Roles",
    "ayudaRoles": "A role is a set of permissions.",
    "persona": "Person",
    "rol": "Role",
    "alcance": "Branches",
    "estado": "Status",
    "tipo": "Type",
    "permisos": "Permissions",
    "personas": "People",
    "activa": "Active",
    "inactiva": "Inactive",
    "deSistema": "Built-in",
    "todasLasSucursales": "All",
    "invitar": "Invite someone",
    "ayudaInvitar": "They will get a link to choose their password.",
    "correo": "Email",
    "elegirRol": "Choose a role",
    "enviarInvitacion": "Invite",
    "invitacionLista": "Invitation ready. Share this link:",
    "nuevoRol": "New role",
    "ayudaNuevoRol": "Choose what someone with this role can do.",
    "codigoDelRol": "Code",
    "nombreDelRol": "Name",
    "tiposDeComprobante": "Vouchers",
    "corregirPersona": "Edit person",
    "ayudaCorregirPersona": "Their role, how far it reaches, and whether they still work here.",
    "corregirRol": "Edit role",
    "ayudaCorregirRol": "Name and what it can do. The code does not change: the rules name it.",
    "estadoDeLaMembresia": "Still works here",
    "ayudaEstadoDeLaMembresia": "Deactivated, they cannot sign in. Nothing is deleted: their work stays in their name.",
    "ayudaTodasLasSucursales": "Unrestricted, they see and work in every branch. Restricted, only in the checked ones.",
    "sucursalPredeterminada": "Usual branch",
    "ayudaSucursalPredeterminada": "The one they start in. Only among the branches they are allowed.",
    "sinPredeterminada": "Let them choose",
    "permisosDelDuenio": "The owner role has every permission and cannot be stripped: a company with no owner cannot be fixed from the inside.",
    "eliminarRol": "Delete the role",
    "confirmarEliminarRol": "The role is deleted. Only possible while nobody holds it.",
    "rolDeSistemaNoSeElimina": "Roles that ship with the system are not deleted.",
    "sinAcotarSucursales": "All branches",
    "sobreUnoMismo": "You cannot change your own role or deactivate yourself: locking yourself out of your own company cannot be fixed from the inside."
  },
  "configuracion": {
    "titulo": "Settings",
    "descripcion": "How your business works.",
    "clases": {
      "libre": "Free",
      "con_corte": "Needs cut-off",
      "fijado_al_inicio": "Set at creation"
    },
    "motivos": {
      "libre": "Applies from now on; it does not touch what is already recorded.",
      "con_corte": "Changing it reinterprets operations already recorded, so it is still locked.",
      "fijado_al_inicio": "It was defined when the company was created."
    },
    "datosDelComercio": "Business details",
    "ayudaDatosDelComercio": "What appears on vouchers and tickets. Tax ID and VAT status do not change here: what was already invoiced carries them."
  },
  "alta": {
    "titulo": "Let's register your business",
    "crear": "Create the business",
    "progreso": "Step {{actual}} of {{total}}",
    "paso1": "Tax details",
    "paso2": "How you work",
    "paso3": "Your first location",
    "nombre": "Business name",
    "ayudaNombre": "As people know it",
    "razonSocial": "Legal name",
    "ayudaRazonSocial": "As it appears on paper",
    "ayudaIdentificacion": "With or without dashes. For example: {{ejemplo}}",
    "tipoDeIdentificacion": "Identification type",
    "condicionIva": "Tax status",
    "pais": "Country",
    "jurisdiccion": "Province, region or department",
    "sinJurisdiccion": "Not specified",
    "monedaDelPais": "It operates in {{moneda}}, the country's currency. It is set when the business is created and can't be changed later.",
    "perfil": "Business profile",
    "elegirPerfil": "Choose a profile",
    "ayudaPerfil": "It sets everything up; you can change what you need afterwards.",
    "sucursalNombre": "Location name",
    "ayudaSucursal": "Main store, downtown branch, warehouse…",
    "sucursalCiudad": "City",
    "loQueSeCrea": "A warehouse, a register and a point of sale are created too, so you can start operating.",
    "sucursalPorDefecto": "Head office"
  },
  "perfiles": {
    "minorista_monotributo": "Retail, simplified regime",
    "minorista_responsable_inscripto": "Retail, VAT registered",
    "mayorista": "Wholesale",
    "mixto": "Mixed"
  },
  "paises": {
    "AR": "Argentina",
    "CL": "Chile",
    "PY": "Paraguay",
    "UY": "Uruguay"
  },
  "jurisdicciones": {
    "AR-C": "Ciudad Autónoma de Buenos Aires",
    "AR-B": "Buenos Aires",
    "AR-K": "Catamarca",
    "AR-H": "Chaco",
    "AR-U": "Chubut",
    "AR-X": "Córdoba",
    "AR-W": "Corrientes",
    "AR-E": "Entre Ríos",
    "AR-P": "Formosa",
    "AR-Y": "Jujuy",
    "AR-L": "La Pampa",
    "AR-F": "La Rioja",
    "AR-M": "Mendoza",
    "AR-N": "Misiones",
    "AR-Q": "Neuquén",
    "AR-R": "Río Negro",
    "AR-A": "Salta",
    "AR-J": "San Juan",
    "AR-D": "San Luis",
    "AR-Z": "Santa Cruz",
    "AR-S": "Santa Fe",
    "AR-G": "Santiago del Estero",
    "AR-V": "Tierra del Fuego",
    "AR-T": "Tucumán",
    "CL-AP": "Arica y Parinacota",
    "CL-TA": "Tarapacá",
    "CL-AN": "Antofagasta",
    "CL-AT": "Atacama",
    "CL-CO": "Coquimbo",
    "CL-VS": "Valparaíso",
    "CL-RM": "Región Metropolitana de Santiago",
    "CL-LI": "Libertador General Bernardo O'Higgins",
    "CL-ML": "Maule",
    "CL-NB": "Ñuble",
    "CL-BI": "Biobío",
    "CL-AR": "La Araucanía",
    "CL-LR": "Los Ríos",
    "CL-LL": "Los Lagos",
    "CL-AI": "Aysén",
    "CL-MA": "Magallanes y de la Antártica Chilena",
    "PY-ASU": "Asunción",
    "PY-1": "Concepción",
    "PY-2": "San Pedro",
    "PY-3": "Cordillera",
    "PY-4": "Guairá",
    "PY-5": "Caaguazú",
    "PY-6": "Caazapá",
    "PY-7": "Itapúa",
    "PY-8": "Misiones",
    "PY-9": "Paraguarí",
    "PY-10": "Alto Paraná",
    "PY-11": "Central",
    "PY-12": "Ñeembucú",
    "PY-13": "Amambay",
    "PY-14": "Canindeyú",
    "PY-15": "Presidente Hayes",
    "PY-16": "Alto Paraguay",
    "PY-19": "Boquerón",
    "UY-AR": "Artigas",
    "UY-CA": "Canelones",
    "UY-CL": "Cerro Largo",
    "UY-CO": "Colonia",
    "UY-DU": "Durazno",
    "UY-FS": "Flores",
    "UY-FD": "Florida",
    "UY-LA": "Lavalleja",
    "UY-MA": "Maldonado",
    "UY-MO": "Montevideo",
    "UY-PA": "Paysandú",
    "UY-RN": "Río Negro",
    "UY-RV": "Rivera",
    "UY-RO": "Rocha",
    "UY-SA": "Salto",
    "UY-SJ": "San José",
    "UY-SO": "Soriano",
    "UY-TA": "Tacuarembó",
    "UY-TT": "Treinta y Tres"
  },
  "condicionesFiscales": {
    "AR": {
      "responsable_inscripto": "Registered VAT taxpayer",
      "monotributo": "Monotributo (simplified regime)",
      "exento": "Exempt",
      "no_responsable": "Not liable",
      "consumidor_final": "Final consumer",
      "no_categorizado": "Uncategorized"
    },
    "CL": {
      "regimen_general": "General regime (art. 14 A)",
      "pro_pyme_general": "Pro Pyme general (art. 14 D No. 3)",
      "pro_pyme_transparente": "Pro Pyme transparent (art. 14 D No. 8)",
      "exento": "VAT exempt",
      "contribuyente": "Taxpayer",
      "consumidor_final": "Final consumer"
    },
    "PY": {
      "ire_general": "IRE general regime",
      "ire_simple": "IRE SIMPLE",
      "ire_resimple": "IRE RESIMPLE",
      "contribuyente": "Taxpayer",
      "consumidor_final": "Final consumer",
      "exento": "Exempt"
    },
    "UY": {
      "regimen_general": "General regime (IRAE and VAT)",
      "literal_e": "Small business (literal E)",
      "monotributo": "Monotributo",
      "monotributo_mides": "MIDES social monotributo",
      "contribuyente": "Taxpayer",
      "consumidor_final": "Final consumer",
      "exento": "Exempt"
    }
  },
  "identificaciones": {
    "CUIT": "CUIT",
    "CUIL": "CUIL",
    "DNI": "DNI",
    "PASAPORTE": "Passport",
    "OTRO": "Other",
    "RUT": "RUT",
    "RUC": "RUC",
    "CI": "Identity card",
    "SIN_IDENTIFICAR": "Unidentified"
  },
  "invitacion": {
    "titulo": "You were invited to a business",
    "tituloFundacion": "Welcome to ActualGold!",
    "subtitulo": "Choose your password to get in.",
    "subtituloFundacion": "Create your account and then we register your business.",
    "nombre": "First name",
    "apellido": "Last name",
    "contrasena": "Password",
    "ayudaContrasena": "At least twelve characters. A phrase beats a strange word.",
    "aceptar": "Create my account",
    "sinToken": "This link is not valid. Ask to be invited again."
  },
  "permisos": {
    "EMPRESA": {
      "CONFIGURACION": {
        "VER": "View settings",
        "EDITAR": "Change settings"
      },
      "SUCURSAL": {
        "VER": "View branches",
        "CREAR": "Create branches",
        "EDITAR": "Edit branches"
      },
      "DEPOSITO": {
        "VER": "View warehouses",
        "CREAR": "Create warehouses",
        "EDITAR": "Edit warehouses"
      },
      "PUESTO_DE_CAJA": {
        "VER": "View registers",
        "CREAR": "Create registers",
        "EDITAR": "Edit registers"
      },
      "PUNTO_DE_VENTA": {
        "VER": "View points of sale",
        "CREAR": "Create points of sale",
        "EDITAR": "Edit points of sale"
      },
      "MONEDA": {
        "VER": "View currencies",
        "EDITAR": "Edit currencies"
      },
      "COTIZACION": {
        "VER": "View exchange rates",
        "CARGAR": "Load exchange rates"
      },
      "CAMPO": {
        "VER": "See custom fields",
        "ADMINISTRAR": "Define custom fields"
      },
      "EMPRESA": {
        "VER": "View the business details",
        "EDITAR": "Edit the business details"
      }
    },
    "ACCESOS": {
      "ROL": {
        "VER": "View roles",
        "CREAR": "Create roles",
        "EDITAR": "Edit roles",
        "ELIMINAR": "Delete roles"
      },
      "MEMBRESIA": {
        "VER": "View the team",
        "INVITAR": "Invite people",
        "EDITAR": "Edit the team",
        "DESACTIVAR": "Deactivate people"
      }
    },
    "AUDITORIA": {
      "REGISTRO": {
        "VER": "View the audit trail"
      }
    },
    "CATALOGO": {
      "ARTICULO": {
        "VER": "View items",
        "CREAR": "Create items",
        "EDITAR": "Edit items"
      },
      "UNIDAD": {
        "VER": "View units of measure",
        "EDITAR": "Edit units of measure"
      },
      "CATEGORIA": {
        "VER": "View categories",
        "EDITAR": "Edit categories"
      }
    },
    "PRECIOS": {
      "LISTA": {
        "VER": "View price lists",
        "CREAR": "Create price lists",
        "EDITAR": "Edit price lists"
      },
      "PRECIO": {
        "VER": "View prices",
        "EDITAR": "Change prices"
      },
      "AUMENTO": {
        "APLICAR": "Raise a whole list"
      }
    },
    "EXISTENCIAS": {
      "SALDO": {
        "VER": "View stock"
      },
      "KARDEX": {
        "VER": "View stock movements"
      },
      "AJUSTE": {
        "APLICAR": "Adjust stock"
      },
      "COSTO": {
        "VER": "View stock cost"
      }
    },
    "CAJA": {
      "TURNO": {
        "VER": "View cash shifts",
        "ABRIR": "Open a cash shift",
        "CERRAR": "Close a cash shift"
      },
      "MOVIMIENTO": {
        "REGISTRAR": "Record cash movements"
      },
      "CONCEPTO": {
        "ADMINISTRAR": "Manage cash concepts"
      }
    },
    "VENTAS": {
      "COMPROBANTE": {
        "VER": "View documents",
        "EMITIR": "Issue documents",
        "ANULAR": "Void a document"
      },
      "PRECIO": {
        "FORZAR": "Sell at a price other than the list price"
      },
      "DESCUENTO": {
        "APLICAR": "Apply discounts on a sale"
      },
      "CREDITO": {
        "AUTORIZAR": "Authorize a sale that exceeds the credit limit"
      },
      "DEVOLUCION": {
        "REGISTRAR": "Register a return",
        "AUTORIZAR_PLAZO": "Authorize a return past the deadline"
      },
      "TIPO_DE_COMPROBANTE": {
        "VER": "View voucher types",
        "ADMINISTRAR": "Configure voucher types"
      },
      "NUMERADOR": {
        "FIJAR": "Set where a numbering series stands"
      }
    },
    "TERCEROS": {
      "TERCERO": {
        "VER": "View parties",
        "CREAR": "Create parties",
        "EDITAR": "Edit parties"
      },
      "PROVEEDOR": {
        "VER": "View suppliers",
        "EDITAR": "Edit the supplier profile"
      },
      "CLIENTE": {
        "VER": "View customers",
        "EDITAR": "Edit the customer profile"
      }
    },
    "COMPRAS": {
      "ORDEN": {
        "VER": "View purchase orders",
        "CREAR": "Create purchase orders",
        "EMITIR": "Issue and cancel orders"
      },
      "RECEPCION": {
        "VER": "View goods receipts",
        "REGISTRAR": "Record goods receipts",
        "ANULAR": "Void a goods receipt"
      },
      "FACTURA": {
        "VER": "View supplier invoices",
        "REGISTRAR": "Record supplier invoices",
        "ANULAR": "Void a supplier invoice"
      },
      "GASTO": {
        "APLICAR": "Allocate expenses into cost"
      }
    },
    "CUENTAS": {
      "CUENTA": {
        "VER": "View accounts receivable"
      },
      "AJUSTE": {
        "APLICAR": "Adjust an account balance"
      },
      "COBRO": {
        "REGISTRAR": "Register payments received",
        "ANULAR": "Void a payment received"
      },
      "PAGO": {
        "REGISTRAR": "Register supplier payments",
        "ANULAR": "Void a payment made"
      }
    },
    "CONTABILIDAD": {
      "PLAN": {
        "VER": "View the chart of accounts",
        "ADMINISTRAR": "Add and edit accounts"
      },
      "ASIENTO": {
        "VER": "View journal entries",
        "REGISTRAR": "Post manual journal entries"
      },
      "REGLA": {
        "ADMINISTRAR": "Configure accounting rules"
      },
      "LIBRO": {
        "VER": "View the accounting books"
      },
      "EJERCICIO": {
        "ADMINISTRAR": "Open, close and reopen fiscal years"
      }
    },
    "IMPUESTOS": {
      "LIBRO_DE_IVA": {
        "GENERAR": "Generate the Digital VAT Book"
      }
    },
    "IMPORTACION": {
      "LOTE": {
        "VER": "View imports",
        "APLICAR": "Import spreadsheets",
        "REVERTIR": "Undo an import"
      }
    },
    "BANCOS": {
      "CUENTA": {
        "VER": "View bank accounts",
        "ADMINISTRAR": "Manage bank accounts"
      },
      "VALOR": {
        "VER": "View the cheque portfolio",
        "MOVER": "Deposit, endorse and reject cheques"
      },
      "CONCILIACION": {
        "HACER": "Reconcile the bank statement"
      }
    },
    "COMISIONES": {
      "REGLA": {
        "ADMINISTRAR": "Configure commissions"
      },
      "DEVENGAMIENTO": {
        "VER": "View what each salesperson earned"
      },
      "LIQUIDACION": {
        "HACER": "Settle commissions"
      }
    },
    "PRODUCCION": {
      "RECETA": {
        "VER": "View assembly recipes",
        "ADMINISTRAR": "Define what a combo is made of"
      },
      "ARMADO": {
        "HACER": "Assemble and disassemble combos"
      }
    },
    "INFORMES": {
      "TABLERO": {
        "VER": "View the dashboard and reports"
      }
    }
  },
  "parametros": {
    "empresa": {
      "zona_horaria": "Time zone",
      "idioma": "System language",
      "moneda_base": "Base currency"
    },
    "impuestos": {
      "modo_de_redondeo": "Rounding mode"
    },
    "existencias": {
      "permitir_negativo": "Allow selling without stock",
      "criterio_de_costeo": "Costing method"
    },
    "caja": {
      "exigir_turno_para_vender": "Require an open register shift to sell"
    },
    "comisiones": {
      "momento_de_devengamiento": "When commission is earned"
    },
    "cuentas_corrientes": {
      "imputacion": "How payments are applied",
      "bloquear_por_mora": "Block sales to overdue customers"
    },
    "devoluciones": {
      "dias_por_defecto": "Days to return",
      "plazo_desde": "The period runs"
    },
    "produccion": {
      "habilitada": "Manufacturing enabled"
    }
  },
  "catalogo": {
    "titulo": "Items",
    "descripcion": "What the business sells and stocks.",
    "nuevo": "New item",
    "buscar": "Search by name or code",
    "codigo": "Code",
    "nombre": "Name",
    "marca": "Brand",
    "unidad": "Unit",
    "tipo": "Type",
    "producto": "Product",
    "servicio": "Service",
    "estado": "Status",
    "activo": "Active",
    "inactivo": "Inactive",
    "variantes": "Variants",
    "sinVariantes": "No variants",
    "vacio": "No items yet.",
    "ayudaCodigo": "The one typed at the counter. It cannot repeat.",
    "ayudaUnidad": "Decides how many decimals a quantity may have: units take none, metres do.",
    "unidadDeStock": "Unit of measure",
    "controlaExistencia": "Affects stock",
    "ayudaControlaExistencia": "A service does not move stock; goods do.",
    "trazabilidad": "Traceability",
    "trazabilidadNinguno": "None",
    "trazabilidadLote": "By batch",
    "trazabilidadLoteConVencimiento": "By batch with expiry",
    "trazabilidadSerie": "By serial number",
    "ayudaTrazabilidad": "With expiry, cost is consumed by earliest expiry rather than oldest purchase.",
    "esInsumo": "Supply only",
    "ayudaEsInsumo": "Bought and consumed in production, never sold: it does not show at the counter.",
    "talles": "Sizes",
    "colores": "Colours",
    "ayudaCombinaciones": "Comma separated. One variant per combination; leave empty and the item has a single one.",
    "codigosDeBarra": "Barcodes",
    "ayudaCodigosDeBarra": "Comma separated. Only for single-variant items: with sizes they are loaded one by one from the item page.",
    "ficha": "Item detail",
    "agregarCodigo": "Add barcode",
    "codigoDeBarra": "Barcode",
    "talle": "Size",
    "color": "Colour",
    "sinDetalle": "—",
    "sinDecimales": "This unit takes no fractions: it sells in whole numbers.",
    "conDecimales": "This unit takes up to {{cantidad}} decimals in the quantity.",
    "combinacionesQueSeCrean_one": "1 variant will be created",
    "combinacionesQueSeCrean_other": "{{count}} variants will be created",
    "variantesContadas_one": "1 variant",
    "variantesContadas_other": "{{count}} variants",
    "corregirArticulo": "Correct the item",
    "corregirAyuda": "Today's catalogue changes. Vouchers already issued keep saying what they said.",
    "desactivar": "Deactivate",
    "activar": "Activate",
    "sinCodigoDeBarra": "No barcode",
    "sacarCodigo": "Remove",
    "paraLaVariante": "For",
    "verCodigos": "Barcodes"
  },
  "precios": {
    "titulo": "Prices",
    "descripcion": "What each thing sells for, on each list.",
    "lista": "List",
    "expresionNeto": "Prices without VAT",
    "expresionFinal": "Prices with VAT included",
    "buscar": "Search by name or code",
    "articulo": "Item",
    "codigo": "Code",
    "unidad": "Unit",
    "precio": "Price",
    "desde": "In force since",
    "sinPrecio": "No price",
    "vacio": "No items to price yet.",
    "sinCambios": "No changes to save",
    "aumentar": "Raise the list",
    "porcentaje": "Percentage",
    "ayudaPorcentaje": "A minus sign lowers prices. It applies to every item already priced on this list.",
    "redondeo": "Round to",
    "redondeoPeso": "Whole units",
    "redondeoCentavo": "Two decimals",
    "redondeoCuatro": "Four decimals",
    "ayudaRedondeo": "Rounding is always declared: raising 12% and leaving prices of 1,234.5678 is correct and commercially useless.",
    "historial": "History",
    "historialDe": "Price history of {{articulo}}",
    "motivo": "Reason",
    "anterior": "Previous",
    "quien": "Who",
    "motivoCarga": "Load",
    "motivoCorreccion": "Correction",
    "motivoAumentoDeLista": "List raise",
    "motivoImportacion": "Import",
    "sinHistorial": "This price has no history yet.",
    "guardar_one": "Save 1 change",
    "guardar_other": "Save {{count}} changes",
    "guardados_one": "Done: 1 price saved.",
    "guardados_other": "Done: {{count}} prices saved.",
    "faltan_one": "1 still without a price",
    "faltan_other": "{{count}} still without a price",
    "aplicaA_one": "It will change 1 price on this list.",
    "aplicaA_other": "It will change {{count}} prices on this list.",
    "aumentados_one": "Done: 1 price updated.",
    "aumentados_other": "Done: {{count}} prices updated.",
    "costoDeReposicion": "Replacement cost",
    "sinCosto": "Load",
    "cargarCosto": "Replacement cost",
    "moneda": "Currency",
    "ayudaCosto": "What it would cost to buy today. It is the basis of the price recalculation.",
    "esPredeterminada": "Default",
    "programar": "Schedule",
    "programarPara": "Schedule a price for {{articulo}}",
    "ayudaProgramar": "Today's price doesn't change: the new one comes in by itself on that day, first thing, and goes into the history.",
    "precioProgramado": "New price",
    "desdeElDia": "From",
    "programados": "Scheduled prices",
    "ayudaProgramados": "What comes in by itself in this list, and when. It can be cancelled while it waits.",
    "precioDeHoy": "Today's price",
    "motivoProgramado": "Scheduled"
  },
  "existencias": {
    "titulo": "Stock",
    "descripcion": "How much of each thing there is, where, and what it cost.",
    "deposito": "Warehouse",
    "todos": "All warehouses",
    "buscar": "Search by name or code",
    "codigo": "Code",
    "articulo": "Item",
    "unidad": "Unit",
    "cantidad": "Quantity",
    "valorizacion": "Valued at",
    "vacio": "No stock recorded yet.",
    "ajustar": "Adjust stock",
    "motivo": "Reason",
    "ayudaMotivo": "Required. An adjustment without a reason is an unexplained discrepancy, and three months later nobody remembers why six were missing.",
    "motivoExistenciaInicial": "Opening stock",
    "motivoConteo": "Count difference",
    "motivoRotura": "Breakage",
    "motivoFaltante": "Shortage",
    "motivoSobrante": "Surplus",
    "motivoUsoInterno": "Internal use",
    "motivoDevolucionAProveedor": "Return to supplier",
    "buscarArticulo": "Item",
    "ayudaCantidad": "Use a minus sign to remove.",
    "costoUnitario": "Unit cost",
    "ayudaCosto": "Required on inbound. It is what will later say what the goods sold cost.",
    "lote": "Batch",
    "vencimiento": "Expiry",
    "ayudaVencimiento": "If set, these goods go out before ones expiring later, even if they arrived after.",
    "agregarLinea": "Add line",
    "quitar": "Remove",
    "aplicar": "Apply the adjustment",
    "aplicado_other": "Done: {{count}} movements recorded.",
    "kardex": "Movements",
    "kardexDe": "Movements of {{articulo}}",
    "cuando": "When",
    "origen": "Source",
    "quien": "Who",
    "observacion": "Note",
    "origenAjuste": "Adjustment",
    "origenVenta": "Sale",
    "origenDevolucion": "Return",
    "origenCompra": "Purchase",
    "origenTransferencia": "Transfer",
    "origenProduccion": "Production",
    "sinMovimientos": "No movements.",
    "entra": "In",
    "sale": "Out",
    "aplicado_one": "Done: {{count}} movement recorded."
  },
  "caja": {
    "titulo": "Register",
    "descripcion": "The shift at this register: what came in, what went out, and what should be there.",
    "puesto": "Register",
    "sinTurno": "This register has no open shift.",
    "abrir": "Open shift",
    "saldoInicial": "Cash in the drawer",
    "ayudaSaldoInicial": "What is there now, counted. It is deliberately not carried over from the last close: carrying it over turns one night\\u2019s error into the next morning\\u2019s starting point.",
    "turnoNumero": "Shift {{numero}}",
    "abiertoPor": "Opened by {{quien}}",
    "movimiento": "Record movement",
    "tipo": "Type",
    "ingreso": "In",
    "egreso": "Out",
    "medioDePago": "Payment method",
    "importe": "Amount",
    "concepto": "Description",
    "efectivo": "Cash",
    "debito": "Debit",
    "credito": "Credit",
    "transferencia": "Transfer",
    "cheque": "Cheque",
    "otro": "Other",
    "cuando": "When",
    "quien": "Who",
    "movimientos": "Shift movements",
    "sinMovimientos": "No movements yet.",
    "arqueo": "Count",
    "esperado": "Cash that should be there",
    "ayudaArqueo": "Only cash is counted. Card and transfer takings are recorded, but they are not in the drawer.",
    "cerrar": "Close shift",
    "declarado": "Cash counted",
    "ayudaDeclarado": "What is actually there, counted now. If it does not match, the difference is recorded under your name.",
    "observacion": "Note",
    "ayudaObservacion": "If there is a difference, whatever you know about why.",
    "diferencia": "Difference",
    "sobra": "Over",
    "falta": "Short",
    "cuadra": "Exact match",
    "cerrado": "Done: shift closed. Expected {{esperado}}, counted {{declarado}}, difference {{diferencia}}.",
    "tipoApertura": "Opening",
    "tipoVenta": "Sale",
    "tipoDevolucion": "Return",
    "tipoIngreso": "In",
    "tipoEgreso": "Out",
    "tipoRedondeo": "Rounding",
    "tipoDiferenciaDeArqueo": "Count difference",
    "historia": "Past shifts",
    "estado": "Status",
    "estadoAbierto": "Open",
    "estadoCerrado": "Closed",
    "sinTurnos": "No shift has been opened yet.",
    "turno": "Shift",
    "queEs": "What is it?",
    "queGasto": "An expense or an income",
    "quePago": "A payment to a supplier",
    "queCobro": "A collection from a customer",
    "queDeposito": "A bank deposit",
    "queDueno": "An owner withdrawal or contribution",
    "clasificarCon": "Classified with",
    "conConcepto": "A concept",
    "conCuenta": "A ledger account",
    "conceptoDeCaja": "Concept",
    "elegirConcepto": "Choose a concept",
    "cuentaDelPlan": "Account",
    "elegirCuenta": "Choose an account",
    "ayudaCuenta": "Only the ones a cash movement can touch: the till, banks, customer and supplier accounts, stock and VAT move through their own operation.",
    "retiro": "Withdrawal",
    "aporte": "Contribution",
    "ayudaDueno": "It goes against the owner's personal account, in equity: it is not a business expense.",
    "sinConceptoDelDueno": "The owner's concept is missing or deactivated: check it in Settings → Cash concepts.",
    "cuentaBancaria": "Bank account",
    "elegirCuentaBancaria": "Choose the account",
    "sinCuentasBancarias": "There are no bank accounts: add them in Banks.",
    "ayudaDeposito": "It leaves the till and reaches the account today.",
    "proveedor": "Supplier",
    "cliente": "Customer",
    "elegirTercero": "Choose who",
    "ayudaTercero": "The cash goes through the {{puesto}} shift. Next to each one, how much is owed.",
    "sinProveedores": "Nothing is owed to any supplier.",
    "sinClientes": "No customer owes anything.",
    "avisoIva": "With a VAT invoice, enter it as a supplier invoice and pay it from here with “A payment to a supplier”, so the VAT is credited. What is entered here goes to expense in full.",
    "detalle": "Detail",
    "ayudaDetalle": "Whatever it takes to understand it later: to whom, why.",
    "seguir": "Continue",
    "revertir": "Reverse",
    "confirmarReversion": "Reverse “{{concepto}}”? The opposite movement is recorded, with its journal entry, and the original stays visible.",
    "tipoCobranza": "Collection",
    "tipoPago": "Payment",
    "tipoDeposito": "Deposit"
  },
  "venta": {
    "mostrador": "Counter",
    "mayorista": "Wholesale entry",
    "descripcionMostrador": "Scan or search by name. Everything works from the keyboard.",
    "descripcionMayorista": "Code, quantity and discount. Enter adds and moves on.",
    "buscar": "Code, barcode or name",
    "codigo": "Code",
    "articulo": "Item",
    "cantidad": "Quantity",
    "precio": "Price",
    "bonificacion": "Disc. %",
    "importe": "Amount",
    "quitar": "Remove",
    "vacia": "The sale is empty. Scan or type a code.",
    "subtotal": "Subtotal",
    "descuento": "Discounts",
    "redondeo": "Rounding",
    "total": "Total",
    "medioDePago": "Payment",
    "efectivo": "Cash",
    "debito": "Debit",
    "credito": "Credit",
    "transferencia": "Transfer",
    "entregado": "Cash given",
    "vuelto": "Change",
    "falta": "Short",
    "cobrar": "Take payment",
    "cancelar": "Cancel the sale",
    "cobrada": "Invoice {{clase}} {{numero}} paid, {{total}}.",
    "vueltoDe": "Change: {{importe}}",
    "sinTurno": "There is no open cash shift at this register. Open it before selling.",
    "irACaja": "Go to Register",
    "sinResultados": "No item matches.",
    "atajos": "F2 takes payment · Esc clears the search · Del removes the line",
    "atajosMayorista": "Enter adds and returns to the code · F2 takes payment · Esc empties the sale",
    "agregar": "Add",
    "puesto": "Register",
    "lista": "Price list",
    "ultimoTicket": "Last: ticket {{numero}} for {{total}}",
    "sinPrecio": "No price loaded",
    "menosUno": "Remove one",
    "masUno": "Add one",
    "sinPrecioEnLista": "Item {{codigo}} has no price on this list. Load it before selling.",
    "cliente": "Customer",
    "consumidorFinal": "Walk-in customer",
    "buscarCliente": "Search customer",
    "quitarCliente": "Remove customer",
    "clase": "Invoice {{clase}}",
    "claseExplicacion": "The letter follows from the shop's VAT status and the customer's. It is not a choice.",
    "sinClientesQueCoincidan": "No customer matches.",
    "debeEnCuenta": "Owes {{importe}} on account",
    "sinDeuda": "No debt",
    "cuenta_corriente": "On account",
    "necesitaCliente": "To sell on account you must identify the customer.",
    "autorizarExceso": "Authorize and charge anyway",
    "excesoNoAutorizado": "Only a manager can authorize exceeding the limit.",
    "anular": "Void this sale",
    "motivoDeAnulacion": "Why it is being voided",
    "confirmarAnulacion": "Void",
    "tipoDeComprobante": "What to issue",
    "sinCobro": "This document takes no payment",
    "emitir": "Issue",
    "dividirElPago": "Split the payment",
    "quitarForma": "Remove this payment method",
    "sobra": "Over",
    "queSeEmite": "What is issued",
    "listaFijadaPorElTipo": "Fixed by the voucher type.",
    "cajaFijadaPorElTipo": "Fixed by the voucher type.",
    "conLaLista": "Prices from the {{lista}} list"
  },
  "ticket": {
    "imprimir": "Print",
    "numero": "Ticket {{numero}}",
    "noFiscal": "Not valid as an invoice",
    "subtotal": "Subtotal",
    "descuento": "Discounts",
    "redondeo": "Rounding",
    "total": "TOTAL",
    "qr": "Code to look up this receipt",
    "consultaConQr": "Scan the code to see this receipt again",
    "verTicket": "View the receipt",
    "cliente": "Customer: {{nombre}}",
    "cuit": "Tax ID {{cuit}}",
    "identificacion": "{{tipo}} {{numero}}",
    "domicilio": "Address: {{domicilio}}",
    "codigoDeTipo": "Code {{codigo}}",
    "fechaDeEmision": "Issue date",
    "puntoDeVenta": "Point of sale",
    "original": "ORIGINAL",
    "receptor": "Customer",
    "sinIdentificar": "Not identified",
    "neto": "Net amount",
    "netoPorAlicuota": "Net at {{alicuota}}%",
    "ivaPorAlicuota": "VAT {{alicuota}}%",
    "ivaIncluido": "VAT {{alicuota}}% included",
    "ivaTotal": "Total VAT",
    "verEnHoja": "View as A4 sheet",
    "verEnRollo": "View as 80 mm roll",
    "cae": "Auth. code {{cae}}",
    "caeVencimiento": "Auth. code expires: {{fecha}}",
    "sinCae": "Invoice pending authorisation",
    "qrDelOrganismo": "Electronic invoice QR code",
    "notaDeCredito": "CREDIT NOTE",
    "ajusta": "Adjusts invoice {{comprobante}}"
  },
  "compras": {
    "proveedores": "Suppliers",
    "compras": "Purchases",
    "descripcionProveedores": "Who the business buys from.",
    "descripcionCompras": "What I ordered, what arrived and what they charged me.",
    "nuevoProveedor": "New supplier",
    "razonSocial": "Legal name",
    "nombreComercial": "Known as",
    "ayudaNombreComercial": "This is what gets typed to find them.",
    "tipoDeIdentificacion": "Type",
    "identificacion": "Tax id",
    "ayudaIdentificacion": "Stored digits only. You can type it with dashes.",
    "condicionIva": "VAT status",
    "diasDePago": "Payment days",
    "ayudaDiasDePago": "Zero is cash. Each invoice due date comes from here.",
    "monedaDelProveedor": "Currency",
    "telefono": "Phone",
    "correo": "Email",
    "ciudad": "City",
    "esProveedor": "Supplier",
    "sinProveedores": "No suppliers yet.",
    "buscarProveedor": "Search by name or tax id",
    "ordenes": "Purchase orders",
    "nuevaOrden": "New order",
    "orden": "Order",
    "proveedor": "Supplier",
    "fecha": "Date",
    "estado": "Status",
    "total": "Total",
    "estadoBorrador": "Draft",
    "estadoEmitida": "Issued",
    "estadoParcial": "Partial",
    "estadoCumplida": "Fulfilled",
    "estadoAnulada": "Cancelled",
    "emitir": "Issue",
    "anular": "Cancel",
    "sinOrdenes": "No purchase orders yet.",
    "articulo": "Item",
    "cantidad": "Quantity",
    "precioUnitario": "Price",
    "bonificacion": "Disc. %",
    "importe": "Amount",
    "agregar": "Add",
    "quitar": "Remove",
    "buscarArticulo": "Item code or name",
    "recepciones": "Goods receipts",
    "nuevaRecepcion": "Record receipt",
    "remito": "Supplier delivery note",
    "deposito": "Warehouse",
    "costoUnitario": "Cost",
    "lote": "Batch",
    "vencimiento": "Expiry",
    "sinRecepciones": "Nothing has arrived yet.",
    "recibida": "Receipt {{numero}} recorded. The order is now {{estado}}.",
    "recibidaSinOrden": "Receipt {{numero}} recorded.",
    "facturas": "Supplier invoices",
    "nuevaFactura": "Record invoice",
    "letra": "Letter",
    "puntoDeVenta": "Point of sale",
    "numero": "Number",
    "neto": "Net",
    "iva": "VAT",
    "percepciones": "Withholdings",
    "vencimientoDePago": "Due",
    "sinFacturas": "No invoices loaded yet.",
    "conDiferencias": "Has differences",
    "sinDiferencias": "Matches",
    "verCotejo": "View the match",
    "cotejo": "Matched against what arrived",
    "facturado": "Invoiced",
    "recibido": "Received",
    "difNoRecibido": "Never arrived",
    "difFacturadoDeMas": "Over-invoiced",
    "difFacturadoDeMenos": "Under-invoiced",
    "difPrecioDistinto": "Different price",
    "sinFacturar": "Arrived and not invoiced",
    "coincide": "Matches",
    "gasto": "Allocate an expense",
    "concepto": "Description",
    "criterio": "Allocate",
    "porImporte": "By amount",
    "porCantidad": "By quantity",
    "ayudaCriterio": "By amount when the expense follows value; by quantity when what you pay for is the truck.",
    "gastoAplicado": "Done. Stock absorbed {{absorbido}} and {{noAbsorbido}} is period cost.",
    "ayudaNoAbsorbido": "The part matching goods already sold cannot be absorbed: the cost of those sales is already recorded.",
    "costoYMargen": "Cost and margin",
    "ultimaCompra": "Last purchase",
    "costoDelStock": "What I hold costs",
    "costoDeReposicion": "Replacement",
    "precioDeVenta": "Selling price",
    "margenReal": "Realised margin",
    "vendidoCantidad": "Sold",
    "ingreso": "Revenue",
    "ayudaMargenReal": "Comes from issued documents, on the net excluding VAT. Returns subtract.",
    "sinDatos": "No data yet.",
    "ivaCobrado": "VAT collected (not income)"
  },
  "clientes": {
    "titulo": "Customers",
    "descripcion": "Who the business sells to. The same party can be both a customer and a supplier.",
    "nuevoCliente": "New customer",
    "buscar": "Search customer",
    "sinClientes": "No customers yet.",
    "razonSocial": "Legal name",
    "nombreComercial": "Trade name",
    "ayudaNombreComercial": "What people call them. It is what you type to find them.",
    "tipoDeIdentificacion": "Tax ID type",
    "identificacion": "Tax ID",
    "ayudaIdentificacion": "Type it as printed, with or without dashes.",
    "condicionIva": "VAT status",
    "limiteDeCredito": "Credit limit",
    "ayudaLimite": "Zero means no credit. Empty too.",
    "sinLimite": "No limit",
    "noSeLeFia": "No credit",
    "diasDePago": "Payment days",
    "ayudaDiasDePago": "Zero means cash.",
    "contado": "Cash",
    "tambienProveedor": "Also",
    "esProveedor": "Supplier",
    "telefono": "Phone",
    "correo": "Email",
    "seguimiento": "Follow-up",
    "filtrarPorEtiqueta": "Filter by tag",
    "todasLasEtiquetas": "All"
  },
  "cuentas": {
    "titulo": "Accounts receivable",
    "descripcion": "Who owes what, largest first.",
    "cliente": "Customer",
    "identificacion": "Tax ID",
    "saldo": "Balance",
    "limite": "Limit",
    "sinLimite": "No limit",
    "aFavor": "{{importe}} in credit",
    "acciones": "Actions",
    "verFicha": "View statement",
    "ajustar": "Adjust",
    "nadieDebe": "Nobody owes anything.",
    "ajustarSaldo": "Adjust the balance",
    "importeDelAjuste": "Amount",
    "ayudaImporteDelAjuste": "Signed: positive raises the debt, negative lowers it.",
    "motivo": "Reason",
    "ayudaMotivo": "It is written to the ledger and the audit trail.",
    "tipos": {
      "venta": "Sale",
      "cobro": "Payment",
      "ajuste": "Adjustment"
    },
    "cobrar": "Collect",
    "cobranza": "Payment from {{cliente}}",
    "medioDePago": "Payment method",
    "importe": "Amount",
    "agregarMedio": "Add another method",
    "quitarMedio": "Remove",
    "pendientes": "Documents with debt",
    "sinPendientes": "No outstanding documents. Whatever is collected stays on account.",
    "pendiente": "Outstanding",
    "aImputar": "Applied",
    "totalCobrado": "Total collected",
    "totalImputado": "Applied to documents",
    "aCuenta": "Paid in advance, unapplied",
    "propuesta": "Proposed: oldest first. You can change it.",
    "registrar": "Register the payment",
    "cobrado": "Receipt {{numero}} for {{total, importe}}. Balance: {{saldo, importe}}.",
    "observaciones": "Notes",
    "enCaja": "Goes into the open register shift",
    "estadoDeCuenta": "Statement",
    "comoCliente": "Customer account",
    "comoProveedor": "Supplier account",
    "fecha": "Date",
    "concepto": "Description",
    "acumulado": "Balance",
    "vence": "Due",
    "antiguedad": "Ageing",
    "alDia": "Current",
    "hasta30": "1 to 30",
    "hasta60": "31 to 60",
    "hasta90": "61 to 90",
    "masDe90": "Over 90",
    "verEstado": "Statement",
    "porTramos": "Debt by age",
    "anular": "Void",
    "motivoDeAnulacion": "Why it is being voided",
    "confirmarAnulacion": "Confirm voiding",
    "anulado": "Voided",
    "anulada": "Voided",
    "numeroDeCheque": "Cheque number",
    "bancoDelCheque": "Bank",
    "fechaDeCobro": "Due date",
    "recibo": "Receipt {{numero}}",
    "aplicar": "Apply"
  },
  "pagos": {
    "titulo": "Supplier payments",
    "descripcion": "Who the business owes, largest first.",
    "proveedor": "Supplier",
    "pagar": "Pay",
    "orden": "Payment order to {{proveedor}}",
    "facturas": "Outstanding invoices",
    "sinFacturas": "No outstanding invoices. Whatever is paid stays on account.",
    "registrar": "Register the payment",
    "pagado": "Order {{numero}} for {{total, importe}}. Balance: {{saldo, importe}}.",
    "nadieCobra": "Nothing is owed to anyone.",
    "sale": "Comes out of the open register shift",
    "endosar": "Endorse cheques from the portfolio",
    "sinCartera": "No cheques in the portfolio.",
    "seCobra": "Due",
    "totalEndosado": "Total endorsed"
  },
  "devoluciones": {
    "titulo": "Returns",
    "descripcion": "The customer brought goods back: find the sale and return what applies.",
    "buscar": "Receipt number",
    "buscarAyuda": "It is the number printed on the paper.",
    "sinResultados": "No sale with that number.",
    "venta": "Receipt {{numero}}",
    "fecha": "Date",
    "total": "Total",
    "cliente": "Customer",
    "consumidorFinal": "Walk-in customer",
    "elegir": "Return from this sale",
    "articulo": "Item",
    "vendida": "Sold",
    "yaDevuelta": "Already returned",
    "disponible": "Left",
    "aDevolver": "Returning",
    "motivo": "Why it is being returned",
    "registrar": "Register the return",
    "hecha": "Return {{numero}} for {{total, importe}}. In cash: {{enEfectivo, importe}}. Credited: {{aCuenta, importe}}.",
    "fueraDePlazo": "Authorize and return anyway",
    "sinAutorizacion": "Only a manager can authorize a return past the deadline.",
    "nadaQueDevolver": "Everything from this sale has been returned.",
    "cambiar": "Exchange for another item",
    "loQueSeLleva": "What they take",
    "buscarArticulo": "Search the item they take",
    "diferenciaAPagar": "Customer pays",
    "diferenciaADevolver": "Refunded",
    "sinDiferencia": "No difference",
    "registrarCambio": "Register the exchange",
    "soloDevolver": "Return only",
    "cambioHecho": "Exchange done: return {{devolucion}} and receipt {{venta}}. Difference: {{diferencia, importe}}.",
    "hechaComoNota": "Credit note {{numero}} for {{total, importe}}. In cash: {{enEfectivo, importe}}. To account: {{aCuenta, importe}}."
  },
  "contabilidad": {
    "titulo": "Chart of accounts",
    "descripcion": "Where everything that happens in the shop is posted.",
    "nueva": "New account",
    "ayudaNueva": "It hangs off the account you pick and inherits its type.",
    "codigo": "Code",
    "nombre": "Name",
    "tipo": "Type",
    "cuelgaDe": "Under",
    "ninguna": "No group",
    "imputable": "Postable",
    "agrupacion": "Group",
    "desactivar": "Deactivate",
    "activar": "Activate",
    "inactiva": "Inactive",
    "renombrar": "Rename",
    "ayudaRenombrar": "Code {{codigo}} stays the same. The books of every period will show the account with its new name.",
    "vacio": "No accounts yet.",
    "ayudaTipo": "Only a top-level group picks it; an account under another inherits its type.",
    "tipos": {
      "activo": "Assets",
      "pasivo": "Liabilities",
      "patrimonio": "Equity",
      "resultado_positivo": "Income",
      "resultado_negativo": "Expenses"
    }
  },
  "asientos": {
    "titulo": "Journal entries",
    "descripcion": "How each operation was recorded in the books.",
    "numero": "Number",
    "fecha": "Date",
    "glosa": "Description",
    "importe": "Amount",
    "cuenta": "Account",
    "debe": "Debit",
    "haber": "Credit",
    "verOperacion": "View operation",
    "vacio": "No entries yet.",
    "totales": "Totals",
    "cuadra": "Balanced",
    "tipo": "Type",
    "tipos": {
      "venta": "Sale",
      "devolucion": "Return",
      "cobranza": "Collection",
      "pago": "Payment",
      "recepcion": "Goods receipt",
      "factura_de_compra": "Purchase invoice",
      "diferencia_de_caja": "Cash difference"
    },
    "referencias": {
      "comprobante": "Document",
      "recepcion": "Goods receipt",
      "factura_de_proveedor": "Supplier invoice",
      "recibo_de_cobranza": "Collection receipt",
      "orden_de_pago": "Payment order",
      "turno_de_caja": "Cash shift"
    }
  },
  "libros": {
    "titulo": "Accounting books",
    "descripcion": "Journal, ledger, trial balance and income statement, by period.",
    "libro": {
      "diario": "Journal",
      "mayor": "Ledger",
      "sumas": "Trial balance",
      "resultados": "Income"
    },
    "desde": "From",
    "hasta": "To",
    "cuenta": "Account",
    "nombre": "Name",
    "elegirCuenta": "Pick an account",
    "numero": "Number",
    "fecha": "Date",
    "glosa": "Description",
    "importe": "Amount",
    "debe": "Debit",
    "haber": "Credit",
    "acumulado": "Balance",
    "saldoAnterior": "Opening balance",
    "saldoFinal": "Closing balance",
    "saldoDeudor": "Debit balance",
    "saldoAcreedor": "Credit balance",
    "totales": "Totals",
    "cuadra": "Balanced",
    "noCuadra": "Out of balance",
    "positivos": "Income",
    "negativos": "Expenses",
    "totalPositivos": "Total income",
    "totalNegativos": "Total expenses",
    "ganancia": "Profit for the period",
    "perdida": "Loss for the period",
    "planilla": "Download spreadsheet",
    "vacio": "No movements in this period."
  },
  "libroDeIva": {
    "titulo": "Digital VAT Book",
    "descripcion": "The RG 4597 files for filing the period with ARCA.",
    "periodo": "Period",
    "generar": "Generate",
    "bajar": "Download",
    "renglones": "{{renglones}} rows",
    "registros": "{{total}} documents",
    "sinMovimientos": "No movements",
    "todaviaNada": "Pick a period and generate the book.",
    "avisoDeCodificacion": "Files download as ISO 8859-1, as the regime requires. Do not re-save them as UTF-8: in a fixed-width file one extra accent shifts the whole row and the agency rejects the file outright."
  },
  "ejercicios": {
    "titulo": "Fiscal years",
    "descripcion": "The accounting period, its closing, and the entries a person writes.",
    "nombre": "Name",
    "periodo": "Period",
    "estado": "Status",
    "estados": {
      "abierto": "Open",
      "cerrado": "Closed"
    },
    "abrir": "Open fiscal year",
    "cerrar": "Close",
    "reabrir": "Reopen",
    "reabrirAyuda": "Nothing is deleted: the closing and income-summary entries are reversed, and who did it and why is recorded.",
    "motivo": "Reason",
    "cerrado": "Closed. Result for the year: {{resultado}}.",
    "asientoManual": "Manual entry",
    "asientoManualAyuda": "The only entry that does not come from an operation. That is why it keeps your name and its reason.",
    "fecha": "Date",
    "glosa": "Description",
    "cuenta": "Account",
    "lado": "Side",
    "elegirCuenta": "Pick an account",
    "otroRenglon": "Another row",
    "desde": "From",
    "hasta": "To",
    "vacio": "No fiscal years yet. Open one so the year can be closed."
  },
  "respaldos": {
    "titulo": "Data backup",
    "ultimo": "Last backup: {{cuando}}",
    "verificado": "Verified",
    "sinVerificar": "Could not be verified",
    "afuera": "Copied off the machine",
    "noSubio": "Could not be copied off",
    "soloAca": "Only on this machine",
    "ninguno": "No backup has been made yet."
  },
  "preparacion": {
    "titulo": "Before you can operate",
    "todoListo": "All set",
    "todoListoAyuda": "The business has everything it needs to sell.",
    "puedeOperar": "Can sell",
    "noPuedeOperar": "Cannot sell yet",
    "resolver": "Fix",
    "yMas": "and {{total}} more",
    "estados": {
      "falta": "Missing",
      "atencion": "Warning",
      "listo": "Ready"
    },
    "requisitos": {
      "SUCURSAL": "An active branch",
      "DEPOSITO": "A warehouse to hold stock",
      "PUNTO_DE_VENTA": "A point of sale to issue documents",
      "PUESTO_DE_CAJA": "A cash register",
      "LISTA_DE_PRECIOS": "A price list",
      "ARTICULO": "At least one item in the catalogue",
      "PRECIO": "Prices loaded: an item without a price cannot be sold",
      "PLAN_DE_CUENTAS": "The chart of accounts",
      "EJERCICIO": "An open fiscal year covering today",
      "CERTIFICADO_FISCAL": "The certificate to request the CAE: without it documents are never authorised",
      "REGLAS_DE_IMPUTACION": "Accounting rules: without them the operation fails on confirmation"
    }
  },
  "importacion": {
    "titulo": "Import",
    "descripcion": "Load the catalogue from a spreadsheet, writing nothing until you confirm.",
    "elegirArchivo": "Pick the spreadsheet",
    "leyendo": "Reading…",
    "vistaPrevia": "This is what will happen",
    "aCrear": "{{total}} will be created",
    "aOmitir": "{{total}} already exist",
    "conError": "{{total}} will not go in",
    "comoSeLeyo": "Read as {{codificacion}}, separated by «{{separador}}». Columns: {{columnas}}.",
    "linea": "Line",
    "clave": "Code",
    "desenlace": "Outcome",
    "desenlaces": {
      "crear": "Created",
      "omitir": "Already there",
      "error": "Rejected"
    },
    "confirmar": "Import {{total}}",
    "nadaSeEscribio": "Nothing has been written yet.",
    "listo": "Imported",
    "resumen": "{{creadas}} created · {{omitidas}} skipped · {{conError}} failed",
    "anteriores": "Previous imports",
    "sinLotes": "Nothing imported yet.",
    "archivo": "File",
    "cuando": "When",
    "quien": "Who",
    "resultado": "Result",
    "entidades": {
      "articulos": "Items",
      "precios": "Prices",
      "existencias": "Stock",
      "terceros": "Customers and suppliers"
    },
    "ayudas": {
      "articulos": "Columns: code and name, optionally unit, VAT and brand.",
      "precios": "Columns: item code and price, optionally the list. Accepts 1.200,50.",
      "existencias": "Columns: item code, quantity and cost, optionally the warehouse. Recorded as opening stock, with its movement, its cost layer and its journal entry.",
      "terceros": "Columns: name, optionally tax ID, VAT status and whether it is a customer or supplier."
    },
    "elOrden": "Order matters: items first, then their prices and stock. Customers and suppliers any time.",
    "deshacer": "Undo",
    "revertido": "Undone",
    "deshecho": "{{total}} rows undone."
  },
  "bancos": {
    "titulo": "Banking",
    "descripcion": "Where the money that is not cash actually is.",
    "enElBanco": "In the bank",
    "enTransito": "Deposited, not credited",
    "enCartera": "On hand",
    "cuentas": "Accounts",
    "cuenta": "Account",
    "banco": "Bank",
    "numero": "Number",
    "saldo": "Balance",
    "cartera": "Cheques on hand",
    "cheque": "Cheque",
    "deQuien": "From",
    "fechaDeCobro": "Due",
    "importe": "Amount",
    "fecha": "Date",
    "estado": "Status",
    "depositos": "Deposits",
    "acreditar": "Mark credited",
    "acreditadoEl": "Credited on {{fecha}}",
    "depositarEn": "Deposit {{total}} into {{cuenta}}",
    "depositarAyuda": "The money is not in the bank until you mark it credited: they are two moments.",
    "sinCuentas": "No bank accounts yet.",
    "sinValores": "No cheques on hand.",
    "sinDepositos": "Nothing deposited yet.",
    "conciliacion": "Reconciliation",
    "elegiCuenta": "Choose an account.",
    "subirExtracto": "Upload statement (CSV)",
    "extractoCargado": "{{cargadas}} lines loaded, {{rechazadas}} discarded.",
    "diceElBanco": "What the bank says and the system doesn't explain",
    "diceElSistema": "What the system says and the bank doesn't confirm",
    "todoExplicado": "Nothing from the bank is left unexplained.",
    "todoConfirmado": "Nothing from the system is left unconfirmed.",
    "sinCandidato": "No candidate",
    "conciliar": "This one",
    "nombre": "Name",
    "agregarCuenta": "Add account"
  },
  "comisiones": {
    "titulo": "Commissions",
    "descripcion": "What each salesperson earned, and what is still owed.",
    "pendiente": "Pending settlement",
    "vendedor": "Salesperson",
    "operaciones": "Operations",
    "total": "Total",
    "liquidar": "Settle",
    "hasta": "Up to",
    "avisoDeLiquidar": "Settled commissions are not recalculated. Anything that appears later goes into the next one.",
    "reglas": "Rules",
    "categoria": "Category",
    "todas": "All",
    "porcentaje": "Rate",
    "sobreElNeto": "The rate applies to the net amount, excluding VAT. A category rule overrides the salesperson base.",
    "liquidaciones": "Settlements",
    "periodo": "Period",
    "sinPendientes": "No pending commissions.",
    "sinReglas": "No commission configured yet.",
    "sinLiquidaciones": "Nothing settled yet."
  },
  "produccion": {
    "titulo": "Combo assembly",
    "descripcion": "Put components together into a product sold as one.",
    "recetas": "Recipes",
    "combo": "Combo",
    "componentes": "Components",
    "componente": "Component",
    "porCombo": "Per combo",
    "elegir": "Choose",
    "elegiUno": "Choose a combo from the list.",
    "armar": "Assemble",
    "cantidad": "Quantity",
    "deposito": "Warehouse",
    "costo": "Cost",
    "quien": "Who",
    "desarmar": "Take apart",
    "esUnDesarmado": "Is a disassembly",
    "historial": "Assemblies",
    "sinArmados": "Nothing has been assembled yet.",
    "sinRecetas": "No item has a recipe.",
    "comoSeCarga": "A recipe declares what a combo is made of and in what quantities.",
    "armado": "Assembled. It cost {{costo}}.",
    "costoSaleDeAhi": "The combo's cost comes from the layers consumed, not from an average."
  },
  "tablero": {
    "elDia": "Today",
    "vendido": "Sales",
    "margen": "Margin",
    "operaciones": "Transactions",
    "contraAyer": "{{valor}} % vs yesterday",
    "promedio": "Monthly average",
    "plata": "Where the money is",
    "enCaja": "In the register",
    "enBanco": "In the bank",
    "enCartera": "In cheques",
    "enTransito": "In transit",
    "deDondeSale": "The register shows open shifts. Bank and cheques belong to the whole company, not to one branch.",
    "cobrar": "Receivables",
    "pendiente": "Outstanding",
    "vencido": "Overdue",
    "faltantes": "Out of stock",
    "faltantesExplicacion": "Items at zero that sold in the last 30 days.",
    "vendidas": "{{cuantas}} in 30 days",
    "porSucursal": "By branch",
    "sucursal": "Branch",
    "contraAyerCorto": "vs yest.",
    "porciento": "{{valor}} %",
    "sucursalEnCero": "A branch with no sales shows zero: that is information too.",
    "hoy": "Today",
    "ayer": "Yesterday",
    "concepto": "Item",
    "detalle": "Detail",
    "valor": "Value",
    "planilla": "Spreadsheet"
  },
  "terceros": {
    "corregir": "Correct the details",
    "corregirAyuda": "This edits the record. Vouchers already issued keep the details they had that day."
  },
  "tiposDeComprobante": {
    "titulo": "Voucher types",
    "descripcion": "Which documents the business issues and what each one does.",
    "codigo": "Code",
    "nombre": "Name",
    "signo": "Impact",
    "queHace": "What it does",
    "estado": "Status",
    "suma": "Adds",
    "resta": "Subtracts",
    "noImpacta": "No impact",
    "mueveStock": "Stock movement",
    "ninguno": "No stock movement",
    "descuenta": "Removes stock",
    "ingresa": "Adds stock",
    "esValorizado": "Has amounts",
    "esValorizadoAyuda": "A delivery note may have none.",
    "haceIva": "Declares VAT",
    "haceIvaAyuda": "Goes into the monthly VAT book.",
    "haceContabilidad": "Posts entries",
    "haceContabilidadAyuda": "Leaves its accounting entry.",
    "tocaCaja": "Touches the register",
    "tocaCajaAyuda": "Moves the open shift.",
    "afectaCuenta": "Moves the account",
    "afectaCuentaAyuda": "Changes what the party owes.",
    "pideCae": "Requests CAE",
    "pideCaeAyuda": "Authorised by the tax authority.",
    "numeraPorPunto": "Numbered per point of sale",
    "numeraPorPuntoAyuda": "Each point keeps its own numbering.",
    "enUso": "In use",
    "apagado": "Off",
    "encender": "Turn on",
    "apagar": "Turn off",
    "nuevo": "New type",
    "corregir": "Correct the type",
    "rigeDesdeAhora": "Changes apply to future documents. Those already issued stay as they are.",
    "laLetraNoSeElige": "The voucher letter is not configured: it follows RG 1415 from your status and the customer’s.",
    "circuito": "Flow",
    "deQueNace": "What {{nombre}} comes from",
    "circuitoAyuda": "Ticked documents can be turned into this one. An invoice comes from a delivery note.",
    "listaDePrecios": "Price list",
    "laQueElComercioTenga": "Whatever the shop has set",
    "listaDePreciosAyuda": "Which prices this type is issued with.",
    "listaEsFija": "The list cannot be changed",
    "listaEsFijaAyuda": "Whoever issues it cannot sell with another list.",
    "requiereOrigen": "Requires a previous document",
    "requiereOrigenAyuda": "Not issued on its own: it comes from one of the circuit types.",
    "dejaPendiente": "Stays pending until converted",
    "dejaPendienteAyuda": "A document of this origin shows on Home until its destination exists.",
    "tiposDelRol": "Which types it can use",
    "todosLosTipos": "With none ticked, it can use all.",
    "numerador": "Numbering series",
    "numeradorAyuda": "Which book it takes its number from. Several types can share one.",
    "elDeSuFamilia": "The one of its fiscal family",
    "puestoDeCaja": "Cash register it posts to",
    "puestoDeCajaAyuda": "With a fixed register, whoever sells does not choose it.",
    "laQueElijaQuienVende": "Whichever the seller picks"
  },
  "conversiones": {
    "titulo": "Invoice what was delivered",
    "descripcion": "Documents that went out and have not been invoiced yet.",
    "queSeEmite": "What to issue",
    "facturar": "Invoice {{cuantos}}",
    "total": "Total",
    "nadaPendiente": "Nothing left to invoice.",
    "sinCliente": "No customer",
    "documentos": "documents from the same customer",
    "numero": "Voucher {{numero}}",
    "hecho": "Done: voucher {{numero}} was issued.",
    "sinCircuito": "No document flow has been set up yet.",
    "comoSeArma": "In Voucher types, tell a type which others it can come from.",
    "enCuenta": "Issued on account: payment comes later, on its own path."
  },
  "rubros": {
    "titulo": "Categories",
    "descripcion": "How items are grouped. One item can be in several.",
    "nuevo": "New category",
    "corregir": "Edit category",
    "nombre": "Name",
    "articulos": "Items",
    "estado": "Status",
    "activo": "Active",
    "inactivo": "Inactive",
    "activar": "Activate",
    "desactivar": "Deactivate",
    "cuelgaDe": "Hangs from",
    "sinPadre": "Top level",
    "ayudaCuelgaDe": "«18k gold» inside «Gold»: search the parent and the children show up.",
    "vacio": "No categories yet",
    "paraQueSirven": "They group items for searching, pricing and paying commission.",
    "delArticulo": "Categories",
    "ningunoElegido": "No category",
    "filtrar": "Filter by category",
    "todos": "All categories"
  },
  "recalculo": {
    "titulo": "Recalculate prices",
    "descripcion": "The price comes from the cost, not from a number typed by hand.",
    "lista": "Price list",
    "base": "Where the price comes from",
    "baseCosto": "From replacement cost",
    "basePrecio": "From the current price",
    "ayudaCosto": "What it would cost to buy today, plus the markup.",
    "ayudaPrecio": "A percentage over the current price. The plain across-the-board increase.",
    "utilidad": "Markup on cost (%)",
    "aumento": "Increase (%)",
    "ayudaUtilidad": "Cost 100 with 40% gives 140. Not the same as margin on sales, shown in the table.",
    "redondeo": "Rounding",
    "valor": "Value",
    "redondeoDecimales": "Decimals",
    "redondeoMultiplo": "To a multiple of",
    "redondeoTerminacion": "Ending in",
    "aQuienesAlcanza": "Which items it reaches",
    "proveedor": "Supplier",
    "rubro": "Category",
    "marca": "Brand",
    "todosLosProveedores": "All",
    "todosLosRubros": "All",
    "ayudaProveedor": "From purchase history: the ones ever bought from them.",
    "verQuePasaria": "See what would happen",
    "aplicar": "Apply to {{count}}",
    "aplicar_one": "Apply to 1 price",
    "aplicar_other": "Apply to {{count}} prices",
    "noEscribeNada": "Looking changes nothing.",
    "aplicado": "{{count}} price updated.",
    "aplicado_one": "1 price updated.",
    "aplicado_other": "{{count}} prices updated.",
    "codigo": "Code",
    "articulo": "Item",
    "costo": "Cost",
    "precioAnterior": "Current price",
    "precioNuevo": "New price",
    "margenSobreVenta": "Margin on sales",
    "sinPrecio": "No price",
    "sinCosto": "Cost missing",
    "sinPrecioBase": "No price to start from",
    "cambian": "Changing",
    "quedanAfuera": "{{count}} left out",
    "quedanAfuera_one": "1 left out",
    "quedanAfuera_other": "{{count}} left out",
    "cotizacionUsada": "{{moneda}} at {{valor}}",
    "ningunaAlcanzada": "The filter reaches no variant",
    "aflojaElFiltro": "Try without supplier, or without category: they combine with «and».",
    "aplicarEl": "Apply on",
    "ayudaAplicarEl": "Empty applies now. With a date, the new prices are scheduled and come in by themselves that day.",
    "programado_one": "Done: {{count}} price scheduled for {{fecha}}.",
    "programado_other": "Done: {{count}} prices scheduled for {{fecha}}.",
    "programado": "Done: {{count}} prices scheduled for {{fecha}}."
  },
  "seguimiento": {
    "titulo": "Follow-up",
    "tipo": "What it was",
    "quePaso": "What happened",
    "volverEl": "Come back on",
    "ayudaVolverEl": "With a date, it stays pending and shows up on Home.",
    "anotar": "Log it",
    "queSePaso": "What happened",
    "sinNotas": "Nothing logged yet.",
    "personas": "People",
    "nombre": "Name",
    "cargo": "Role",
    "telefono": "Phone",
    "etiquetas": "Tags",
    "sinEtiquetas": "No tags created yet.",
    "venceEl": "Due {{fecha}}",
    "hecho": "Done",
    "marcarHecho": "Mark done",
    "tipos": {
      "llamada": "Call",
      "visita": "Visit",
      "correo": "Email",
      "mensaje": "Message",
      "nota": "Note"
    }
  },
  "pendientes": {
    "titulo": "What to do",
    "vencido": "Overdue",
    "vencidos": "{{count}} overdue",
    "vencidos_one": "1 overdue",
    "vencidos_other": "{{count}} overdue"
  },
  "circuito": {
    "titulo": "Waiting to be documented",
    "esperan": "{{tipo}} waiting for its {{destino}}",
    "resolver": "Resolve"
  },
  "numeradores": {
    "titulo": "Numbering series",
    "descripcion": "The shop's number books. Any voucher can use any of them.",
    "nuevo": "New series",
    "corregir": "Edit series",
    "codigo": "Code",
    "nombre": "Name",
    "codigoAyuda": "Short and uppercase. It is what gets printed on the voucher.",
    "puntoDeVenta": "Point of sale",
    "puntoAyuda": "The four digits come from here. It cannot be changed later.",
    "puntoNoSeCambia": "The point of sale cannot be changed: its four digits are printed on every voucher it issued.",
    "vaPor": "Stands at",
    "tiposQueLoUsan": "Types",
    "estado": "Status",
    "activo": "Active",
    "inactivo": "Inactive",
    "activar": "Activate",
    "desactivar": "Deactivate",
    "fijar": "Set the number",
    "ultimoNumero": "Last number issued",
    "fijarAyuda": "Forward only: going back would repeat numbers already issued.",
    "vacio": "No numbering series yet",
    "paraQueSirven": "Each voucher type takes its number from one. With none, they number as always."
  },
  "campos": {
    "titulo": "Custom fields",
    "descripcion": "The data your shop needs and no record had.",
    "nuevo": "New field",
    "corregir": "Edit field",
    "deQueFicha": "On which record",
    "nombre": "Name",
    "codigo": "Code",
    "codigoAyuda": "What it will be searched by. Proposed from the name.",
    "tipo": "Type",
    "tipoAyuda": "The type cannot be changed later: deactivate the field and create another.",
    "tipoNoSeCambia": "The type cannot be changed: it would turn the loaded values into something else.",
    "opciones": "Options",
    "opcionesAyuda": "One per line.",
    "opcionEnUso": "An option chosen on some record cannot be removed.",
    "ayuda": "Help",
    "obligatorio": "Required",
    "obligatorioAyuda": "Without a value the record cannot be saved.",
    "estado": "Status",
    "activo": "Active",
    "inactivo": "Inactive",
    "activar": "Activate",
    "desactivar": "Deactivate",
    "si": "Yes",
    "vacio": "No custom fields yet",
    "paraQueSirven": "Add the data your shop needs and no record had.",
    "enLaFicha": "Custom fields",
    "entidades": {
      "articulo": "Items",
      "tercero": "Customers and suppliers"
    },
    "tipos": {
      "texto": "Text",
      "texto_largo": "Long text",
      "texto_enriquecido": "Rich text",
      "numero": "Number",
      "fecha": "Date",
      "si_no": "Yes or no",
      "lista": "Dropdown list",
      "imagen": "Image",
      "archivo": "File"
    },
    "verElArchivo": "Open the file",
    "sacarElArchivo": "Remove it",
    "elegirArchivo": "Choose file",
    "cambiarArchivo": "Change",
    "subiendo": "Uploading…"
  },
  "ficha": {
    "datos": "Details",
    "unidadFija": "Measured in {{unidad}}. The unit does not change: it would reinterpret quantities already recorded.",
    "variante": "Variant",
    "existencias": "How much there is",
    "sinExistencias": "No stock of this yet",
    "porVariante": "For the first variant.",
    "precios": "What it sells for",
    "ayudaPrecios": "In every list, and where it is still missing.",
    "sinPrecio": "No price",
    "sinPrecios": "No price lists yet",
    "movimientos": "What moved",
    "ayudaMovimientos": "Every movement in and out, across all warehouses.",
    "sinMovimientos": "Nothing has moved yet",
    "compras": "Who it was bought from",
    "ayudaCompras": "From goods receipts, which are what bring the stock in.",
    "sinCompras": "Not purchased yet",
    "quienLoLleva": "Who buys it",
    "ayudaQuienLoLleva": "Named customers. Counter sales with no customer do not count.",
    "sinClientes": "No customer has bought it yet",
    "importe": "Amount",
    "ultimaVez": "Last time",
    "gestionar": "Manage",
    "tambienProveedor": "Also a supplier",
    "tambienCliente": "Also a customer",
    "perfilDeCliente": "How much credit",
    "ayudaPerfilDeCliente": "The cap on the running account.",
    "limiteVacio": "Blank means no cap. Zero means no credit at all.",
    "perfilDeProveedor": "How they get paid",
    "ayudaPerfilDeProveedor": "Days from the invoice to the due date.",
    "cuentaCorriente": "Running account",
    "ayudaCuentaCliente": "What they owe as a customer. It does not net against what we owe them.",
    "ayudaCuentaProveedor": "What we owe as a supplier. It does not net against what they owe us.",
    "sinCuenta": "No movements yet",
    "comprobantes": "What was sold to them",
    "ayudaComprobantes": "The latest vouchers, voided ones included.",
    "sinComprobantes": "Nothing sold to them yet",
    "queSeLleva": "What they buy",
    "ayudaQueSeLleva": "By item, from most to least spent.",
    "sinVentas": "They have not bought anything yet",
    "ayudaSeguimiento": "What happened with this customer and what to do next.",
    "seguimientoAparte": "The log and its follow-ups open in their own window.",
    "ayudaOrdenes": "What was ordered from them.",
    "sinOrdenes": "Nothing ordered yet",
    "ayudaRecepciones": "What actually arrived.",
    "sinRecepciones": "Nothing has arrived yet",
    "ayudaFacturas": "What they charged, with discrepancies flagged.",
    "sinFacturas": "They have not invoiced yet",
    "listaDePrecios": "Price list",
    "ayudaListaDePrecios": "If set, they are sold at that list while it is active and in date, unless the voucher type fixes another.",
    "listaQueNoSirve": "That list is not offered today (it is deactivated or out of date): meanwhile they are sold at the next one in the chain.",
    "sinListaPropia": "Whichever applies"
  },
  "plataforma": {
    "titulo": "Platform",
    "descripcion": "Who gets into this installation. What happens inside each business is not visible from here.",
    "invitaciones": "Invitations to found a business",
    "ayudaInvitaciones": "Each one is a single-use link, valid for fourteen days.",
    "invitar": "Invite someone to found a business",
    "ayudaInvitar": "They accept, choose a password and enter their business details, which they know better than we do.",
    "correo": "Email",
    "comercio": "Business",
    "ayudaComercio": "Its name, if known. It is there to recognise the invitation in the list.",
    "notas": "Notes",
    "emitir": "Issue the invitation",
    "invitacionLista": "The invitation is issued. The link is shown here so you can pass it on any way you like — email, message, in person — without depending on any email having gone out.",
    "enlace": "Link",
    "emitida": "Issued",
    "vence": "Expires",
    "estado": "Status",
    "estados": {
      "pendiente": "Pending",
      "aceptada": "Accepted",
      "revocada": "Revoked",
      "vencida": "Expired"
    },
    "revocar": "Revoke",
    "sinInvitaciones": "Nobody has been invited yet",
    "sinComercio": "No name yet",
    "quienSos": "You are signed in as a platform administrator.",
    "comercios": "Businesses",
    "ayudaComercios": "That they exist and whether they are active. What is inside them is not visible from here.",
    "nombre": "Business",
    "identificacion": "Tax ID",
    "fundado": "Founded",
    "activo": "Active",
    "suspendido": "Suspended",
    "suspender": "Suspend",
    "reactivar": "Reactivate",
    "confirmarSuspension": "Nobody will be able to sign in, and anyone inside is locked out on their next request. Nothing is deleted.",
    "sinComercios": "No businesses yet",
    "administradores": "Who administers the installation",
    "ayudaAdministradores": "Appointed and removed from the server console. Here they can only be seen.",
    "nuevoComercio": "New business",
    "ayudaNuevoComercio": "Created with its branch, its roles and its owner ready to sign in. It is the same founding as by invitation.",
    "elComercio": "The business",
    "elDuenio": "Who will run it",
    "sucursal": "First branch",
    "correoDelDuenio": "Owner's email",
    "nombreDelDuenio": "Owner's name",
    "claveDelDuenio": "Initial password",
    "ayudaClaveDelDuenio": "Who runs this business, and two ways to reset their password. It is the person’s account: if they own another business, the password changes for both.",
    "crear": "Create the business",
    "comercioCreado": "The business is created. These are the sign-in details; the password will not be shown again.",
    "comercioCreadoConCuenta": "The business is created and added to the account that already had that email: they sign in with their usual password.",
    "entrarEn": "Sign in at",
    "editar": "Edit",
    "editarComercio": "Edit the business",
    "ayudaEditarComercio": "The details. Tax ID and VAT status do not change: what was already invoiced carries them.",
    "domicilio": "Address",
    "ciudad": "City",
    "codigoPostal": "Postal code",
    "telefono": "Phone",
    "correoDelComercio": "Business email",
    "borrar": "Delete",
    "ayudaBorrar": "Deleted with everything in it: sales, people, files. No way back. Only a suspended business, and typing its ID.",
    "escribiLaIdentificacion": "Type the ID to confirm",
    "borrarDefinitivamente": "Delete permanently",
    "sinDuenios": "This business has no active owner",
    "claveProvisoria": "Set a temporary password",
    "ayudaClaveProvisoria": "All their sessions are closed and they must choose their own on sign-in. Shown once.",
    "generarOtra": "Generate another",
    "aplicar": "Apply",
    "provisoriaPuesta": "Temporary password set. Pass it on; they must change it on sign-in.",
    "enlaceDeRecuperacion": "Generate a link",
    "ayudaEnlaceDeRecuperacion": "They choose their password through the link. It never passes through you. It expires, and works once.",
    "enlaceListo": "Link ready. Pass it on any way you like.",
    "restablecerClave": "Owner's password"
  },
  "clave": {
    "miClave": "Change my password",
    "titulo": "Change password",
    "ayuda": "With the current one and the new one. Your other sessions are closed; this one stays.",
    "actual": "Current password",
    "nueva": "New password",
    "repetir": "Repeat the new password",
    "ayudaNueva": "12 characters or more. A phrase only you know.",
    "noCoinciden": "The two new passwords do not match.",
    "cambiar": "Change password",
    "cambiada": "The password was changed.",
    "elegi": "Choose your password",
    "ayudaElegi": "You signed in with a temporary password. Before going on, choose one only you know: the temporary one goes in “current password”."
  },
  "recuperacion": {
    "titulo": "Choose your new password",
    "ayuda": "This link works once.",
    "listo": "The password was changed. You can sign in now.",
    "entrar": "Go to sign in",
    "sinToken": "This link carries no code. Ask for a new one.",
    "confirmar": "Save password"
  },
  "listasDePrecios": {
    "titulo": "Price lists",
    "descripcion": "The prices things are sold at. A sale takes the customer's list, the voucher type's, the cash desk's or the branch's, and if there's none, the default.",
    "nueva": "New list",
    "corregir": "Edit the list",
    "codigo": "Code",
    "nombre": "Name",
    "moneda": "Currency",
    "expresionDelPrecio": "The price is",
    "ayudaExpresion": "Final: what the customer pays, with VAT. Net: without VAT, as wholesale thinks.",
    "expresion": {
      "final": "Final price",
      "neto": "Net price"
    },
    "vigencia": "Valid",
    "siempre": "Always",
    "desde": "From {{desde}}",
    "hasta": "Until {{hasta}}",
    "entre": "From {{desde}} to {{hasta}}",
    "vigenteDesde": "Valid from",
    "vigenteHasta": "Valid until",
    "ayudaVigencia": "Without dates, it's always valid. Out of dates it isn't offered, and whoever has it assigned sells with the next one.",
    "tramos": "Tiers",
    "sinTramos": "—",
    "tramo": "from {{desde}}: {{porcentaje}}%",
    "tramosDe": "Quantity tiers of {{lista}}",
    "ayudaTramos": "A quantity discount for every item in the list: from 10 units, 5% off. The highest tier the line reaches applies.",
    "desdeCantidad": "From quantity",
    "descuento": "Discount %",
    "agregarTramo": "Add tier",
    "estado": "Status",
    "predeterminada": "Default",
    "activa": "Active",
    "inactiva": "Inactive",
    "fueraDeFecha": "Out of dates",
    "hacerPredeterminada": "Make default",
    "eliminar": "Delete",
    "desactivar": "Deactivate",
    "activar": "Activate",
    "eliminada": "List deleted.",
    "desactivada": "The list has already sold, so it was deactivated: it isn't offered anymore and its sales still say which list they used.",
    "copiarDe": "Copy prices from",
    "sinCopiar": "Don't copy: start empty",
    "ayudaCopiar": "The new one inherits the currency and expression of the copied one.",
    "porcentaje": "Percentage",
    "ayudaPorcentaje": "On the other list's price. With a minus sign it's a discount: -15.",
    "redondearA": "Round to a multiple of",
    "ayudaRedondeo": "Empty rounds to two decimals. 10 makes prices end in zero, never downward.",
    "copiados": "List created with {{cantidad}} prices copied.",
    "vacio": "There are no lists yet.",
    "predeterminadaSinVigencia": "The default list has no validity period: it's what guarantees there is always a price.",
    "asignada": "Price list"
  },
  "cajaDelEfectivo": {
    "etiqueta": "Cash till",
    "elegir": "Choose the till",
    "ayuda": "The cash goes through that till’s open shift, and the count includes it.",
    "sinCajas": "No till has an open shift: the cash goes through none.",
    "fija": "The cash goes through the {{puesto}} shift."
  },
  "conceptosDeCaja": {
    "titulo": "Cash concepts",
    "descripcion": "Why money comes in or out of the till when it is not a sale. Whoever enters it picks the concept; the ledger account is chosen here, once.",
    "nombre": "Name",
    "sentido": "For",
    "cuenta": "Ledger account",
    "cuentaNoDisponible": "The account no longer takes cash movements: choose another.",
    "estado": "Status",
    "activo": "Active",
    "inactivo": "Deactivated",
    "corregir": "Edit",
    "ayudaCorregir": "Changing the account applies to the next movements: what is already posted is not rewritten.",
    "nuevo": "New cash concept",
    "vacio": "There are no concepts yet.",
    "sentidos": {
      "egreso": "Outgoing",
      "ingreso": "Incoming",
      "ambos": "Both"
    }
  }
}
